import { render, staticRenderFns } from "./OpenModalRenderer.vue?vue&type=template&id=c6d25002"
import script from "./OpenModalRenderer.vue?vue&type=script&lang=js"
export * from "./OpenModalRenderer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports